/**
 * Created by apokdev on 6/6/17.
 */
import React, { Component } from 'react';

export default class extends Component{
    render(){
        return(
            <div className="filler">
                <p><img src='https://www.google.com/images/spin-32.gif' alt=""/></p>
                Cargando...
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/Vacio.js